module.exports = __webpack_public_path__ + "img/174.01b4e0e5.png";